/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalEntityDetails
 */
export interface LegalEntityDetails {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    name?: string;
}

/**
 * Check if a given object implements the LegalEntityDetails interface.
 */
export function instanceOfLegalEntityDetails(value: object): value is LegalEntityDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function LegalEntityDetailsFromJSON(json: any): LegalEntityDetails {
    return LegalEntityDetailsFromJSONTyped(json, false);
}

export function LegalEntityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function LegalEntityDetailsToJSON(value?: LegalEntityDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

